import { TaskList } from '@/components/logbook/task/TaskList';
import { useTranslation } from 'react-i18next';
import { Box, Button, FormGroup, TextField } from '@mui/material';
import { useUserContext } from '@/contexts/UserContext';
import { ReactElement, useState } from 'react';
import { getTasks } from '@/generated/client/driveon-api/driveon-api';
import { OtherTasksDialog } from '@/components/logbook/task/OtherTasksDialog';

import './MyTasks.css';

export function MyTasks() {
  const { t } = useTranslation();
  const userCtx = useUserContext();
  const [kid, setKid] = useState<string>('');
  const [dialog, setDialog] = useState<ReactElement | undefined>(undefined);

  async function showExtraTasks(extraKid: string) {
    function onClose() {
      setDialog(undefined);
    }

    if (extraKid) {
      const response = await getTasks({ extraKid: extraKid }).catch((error) => {
        console.warn('getTaskWithKid(): Api failed: getTasks -> ', error);
      });

      if (response && response.status == 200) {
        const data = response.data;
        console.log('getTaskWithKid(): Api called: getTasks');
        setDialog(<OtherTasksDialog onClose={onClose} tasks={data} kid={extraKid} />);
      }
    }
  }

  return (
    <>
      <div className="my-tasks">
        <div className="title">{t('myTasks.title')}</div>
        {userCtx.user?.admin && (
          <>
            {t('menetlevel.choosetask.otheruser')}
            <Box sx={{ display: 'flex', marginLeft: 'auto', marginRight: 'auto' }}>
              <FormGroup row>
                <TextField
                  id="outlined-start-adornment"
                  name="extraKid"
                  label={'KID'}
                  placeholder="..."
                  variant="outlined"
                  value={kid}
                  size="small"
                  onChange={(e) => setKid(e.target.value)}
                />
                <Button onClick={() => showExtraTasks(kid)} variant="contained" >
                  {t('general.query')}
                </Button>
              </FormGroup>
            </Box>
            <br />
          </>
        )}
        <div className="date">
          <span>{new Date().toLocaleDateString('hu-HU')}</span>
        </div>
        <TaskList setTask={() => undefined} enableSelect={false} />
      </div>
      {dialog}
    </>
  );
}
